﻿import { useState, useEffect } from "react";
import "./TypedSubtitle.css";

const PHRASES = [
  "Data Scientist",
  "Researcher in Visualisation",
  "Game Designer",
  "Data Visualisation Designer",
  "Visual Storyteller",
];

export default function TypedSubtitle() {
  const [charIndex, setCharIndex] = useState(0);
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = PHRASES[phraseIndex];

    if (!deleting && charIndex < current.length) {
      const t = setTimeout(() => setCharIndex((c) => c + 1), 65);
      return () => clearTimeout(t);
    }
    if (!deleting && charIndex === current.length) {
      const t = setTimeout(() => setDeleting(true), 2000);
      return () => clearTimeout(t);
    }
    if (deleting && charIndex > 0) {
      const t = setTimeout(() => setCharIndex((c) => c - 1), 38);
      return () => clearTimeout(t);
    }
    if (deleting && charIndex === 0) {
      setDeleting(false);
      setPhraseIndex((i) => (i + 1) % PHRASES.length);
    }
  }, [charIndex, deleting, phraseIndex]);

  return (
    <p className="typed-subtitle">
      {PHRASES[phraseIndex].slice(0, charIndex)}
      <span className="typed-cursor">|</span>
    </p>
  );
}
